<template>
    <el-dialog :visible.sync="show" title="货转单生成">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="下家承担日期">
                <el-date-picker v-model="model.downDate" type="date">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="库区">
                <div class="line-container">
                    <el-input style="width:350px" v-model="house" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('house')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('house')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="岸罐" v-if="model.house && model.house.name == '太仓阳鸿石化有限公司'">
                <el-input v-model="model.tank"></el-input>
            </el-form-item>
            <el-form-item label="卖方" v-if="model.house && model.house.name != '太仓阳鸿石化有限公司'">
                <div class="line-container">
                    <el-input style="width:350px" v-model="purchaser0" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('purchaser0')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('purchaser0')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="转出方">
                <div class="line-container">
                    <el-input style="width:350px" v-model="purchaser1" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('purchaser1')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('purchaser1')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="转入方">
                <div class="line-container">
                    <el-input style="width:350px" v-model="purchaser2" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('purchaser2')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('purchaser2')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="编号日期">
                <el-date-picker v-model="model.date" type="date">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="序号">
                <el-input v-model="model.no"></el-input>
            </el-form-item>
            <el-form-item label="编号">
                <el-input v-model="orderNO" disabled></el-input>
            </el-form-item>
            <el-form-item label="数量">
                <el-input v-model="model.count"></el-input>
            </el-form-item>
            <el-form-item label="仓储单价" v-if="model.house && model.house.name == '太仓阳鸿石化有限公司'">
                <el-input v-model="model.price"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="model.remarks"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectImage, selectHouse, selectPurchaser } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgSuccess } from "../../util/toast";
import dayjs from "dayjs";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null
        };
    },
    created() {},
    computed: {
        house() {
            if (this.model.house) {
                return this.model.house.name;
            } else {
                return "";
            }
        },
        purchaser0() {
            if (this.model.purchaser0) {
                return this.model.purchaser0.name;
            } else {
                return "";
            }
        },
        purchaser1() {
            if (this.model.purchaser1) {
                return this.model.purchaser1.name;
            } else {
                return "";
            }
        },
        purchaser2() {
            if (this.model.purchaser2) {
                return this.model.purchaser2.name;
            } else {
                return "";
            }
        },
        orderNO() {
            if (
                this.model &&
                this.model.date &&
                this.model.no &&
                this.model.purchaser1 &&
                this.model.purchaser1.header
            ) {
                return `${this.model.purchaser1.header}${dayjs(
                    this.model.date
                ).format("YYYYMMDD")}${this.model.no}`;
            } else {
                return "";
            }
        }
    },
    methods: {
        async chooseItem(key) {
            if (key == "house") {
                let item = await selectHouse();
                this.$set(this.model, key, item);
            } else if (key == "purchaser0") {
                let item = await selectPurchaser();
                this.$set(this.model, key, item);
            } else if (key == "purchaser1") {
                let item = await selectPurchaser();
                this.$set(this.model, key, item);
            } else if (key == "purchaser2") {
                let item = await selectPurchaser();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = {
                date: new Date(),
                downDate: new Date(),
                no: "",
                tank: "T",
                price: "1.2",
                ...item
            };
            if (this.model.orderNO) {
                let date = dayjs(this.model.date).format("YYYYMMDD");
                let no = this.model.orderNO.split(date);
                this.model.no = no[1];
            }
        },
        async save() {
            this.loadingSave = true;
            if (this.model.no) {
                this.model.orderNO = this.orderNO;
            }
            await HttpClient.put("/restful", {
                model: "Forward",
                cond: this.model._id,
                updates: this.model
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        }
    }
};
</script>

<style scoped lang="less">
</style>

        